import React from 'react'
import CheckboxButton from '../../../../components/CheckboxButton';
import TextInput from '../../../../components/TextInput';

const ReferralsSection = ({ formAdvanceData, setFormAdvanceData, handleChange, handleSearchTalent }) => {
  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>リファラル</p>
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-3 gap-10'>
          <div className='col-span-1 flex items-end'>
            <div onClick={(e) => {
                e.stopPropagation();
                setFormAdvanceData((prev) => ({
                  ...prev,
                  is_referred: formAdvanceData.is_referred ? null : true,
                }));
            }} className="w-full px-3 py-[0.375rem] flex items-center gap-3 rounded-[0.25rem] border border-[#E0E0E0] hover:bg-[#FFF3E5] hover:cursor-pointer">
                <div className="shrink-0">
                  <CheckboxButton
                    name={'is_referred'}
                    label={'リファラル登録'}
                    value={Boolean(formAdvanceData.is_referred)}
                    onChange={(e:any) => {
                      setFormAdvanceData((prev) => ({
                        ...prev,
                        is_referred: formAdvanceData.is_referred ? null : true,
                      }));
                    }}
                  />
                </div>
            </div>
          </div>
          <div className='col-span-1'>
            <label className="block text-sm mb-2 alu-text-base-1">紹介者 氏名・ＩＤ</label>
            <TextInput
              size="md"
              name="referrer_talent"
              value={formAdvanceData.referrer_talent}
              onChange={handleChange}
              onKeyDown={(e: any) => e.key === "Enter" && handleSearchTalent(e)}
              placeholder=""
              clearIcon={true}
              onClearQuery={() => {
                setFormAdvanceData((prev: any) => ({
                  ...prev,
                  referrer_talent: '',
                }));
              }}
            />
          </div>
          <div className="col-span-1"></div>
        </div>
      </div>
    </>
  )
}

export default ReferralsSection